import RexPanel from './RexPanel';
import { RexProvider } from '../context/RexContext';

/**
 * v3 workspace main column: scrollable content + Rex provider/panel.
 * @param {object} rexBase — { orgName, programmeName, projectName, layer }
 */
export default function WorkspaceFrame({ children, rexBase = {} }) {
  return (
    <RexProvider base={rexBase}>
      <div className="workspace-frame">
        <div className="workspace-content">
          {children}
        </div>
        <RexPanel />
      </div>
    </RexProvider>
  );
}
